import { CSSObject } from '@chakra-ui/react';

export const IconSGM: CSSObject = {
  boxSize: '30px',
  display: 'block',
  mr: '2',
  color: 'alpha.600',
};
